var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 6.5,
  width: 31,
  height: 23,
  rx: 1.5,
  fill: "#8a6238"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 8.8,
  y: 8.3,
  width: 8.4,
  height: 8.8,
  fill: "#efe6d4"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 18.3,
  y: 8.3,
  width: 8.4,
  height: 8.8,
  fill: "#efe6d4"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 27.8,
  y: 8.3,
  width: 8.4,
  height: 8.8,
  fill: "#efe6d4"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 8.8,
  y: 18.6,
  width: 8.4,
  height: 8.8,
  fill: "#efe6d4"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 18.3,
  y: 18.6,
  width: 8.4,
  height: 8.8,
  fill: "#efe6d4"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 27.8,
  y: 18.6,
  width: 8.4,
  height: 8.8,
  fill: "#efe6d4"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 9.8,
  y: 11.5,
  width: 6.4,
  height: 4.4,
  fill: "#dfe6ec"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m9.8 11.7 3.2 2.2 3.2-2.2",
  fill: "none",
  stroke: "#8f9ba3",
  strokeWidth: 0.8
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 28.8,
  y: 21.8,
  width: 6.4,
  height: 4.4,
  fill: "#dfe6ec"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m28.8 22 3.2 2.2 3.2-2.2",
  fill: "none",
  stroke: "#8f9ba3",
  strokeWidth: 0.8
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-6 27 34.5)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 30.5,
  width: 14,
  height: 8.5,
  rx: 1,
  fill: "#dfe6ec"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.4 31 6.6 4.6 6.6-4.6",
  fill: "none",
  stroke: "#8f9ba3",
  strokeWidth: 1.1
}));

function SvgMailServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailServices);
export default __webpack_public_path__ + "static/media/mail-services.a4bdd21053a0738a33431181182cf308.svg";
export { ForwardRef as ReactComponent };